import { render, staticRenderFns } from "./OfferGroup.vue?vue&type=template&id=00e54f6b&scoped=true"
import script from "./OfferGroup.vue?vue&type=script&lang=ts"
export * from "./OfferGroup.vue?vue&type=script&lang=ts"
import style0 from "./OfferGroup.vue?vue&type=style&index=0&id=00e54f6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e54f6b",
  null
  
)

export default component.exports